import { store } from '@betacrew/jars-flux';

export const componentKey = "INTEGRATION_FILE_IMPORT";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setFormAndTaxYearList: (state, action) => {
            state.formAndTaxYearList = action.payload;
        },
        setUploadedFile: (state, action) => {
            state.uploadedFile = action.payload;
        },
        setUploadedFilePath: (state, action) => {
            state.uploadedFilePath = action.payload;
        },
        setImportData: (state, action) => {
            state.importData = action.payload;
        },
        setFormSettings: (state, action) => {
            state.formSettings = action.payload;
        },
        setIsImportDataGridViewLoaded: (state, action) => {
            state.isImportDataGridViewLoaded = action.payload;
        },

    },
    initialReducerState: {
        loadingState: false,
        formAndTaxYearList: {},
        uploadedFile: null,
        uploadedFilePath: null,
        importData: null,
        formSettings: null,
        isImportDataGridViewLoaded: false
    }
});

export const { setFormAndTaxYearList, setUploadedFile, setUploadedFilePath, setImportData, setFormSettings, setIsImportDataGridViewLoaded, setLoadingState } = actions;